import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import generateRandomString from "../../../utils/generateRandomString";
import { TransactionSubtype } from "../../Dashboard/constants/transactionSubtype";
import { TransactionType } from "../../Dashboard/constants/transactionType";
import { FartherAccountId, LocalDate, Ticker, } from "../../Types";
import ValidationError from "../../ZodError";
export const url = (accountGroupId) => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/account-groups/v3/group/${accountGroupId}/get-group-events`
        : `https://middleware.uat.farther.com/account-groups/v3/group/${accountGroupId}/get-group-events`;
};
export const StartingMarketValue = z.object({
    date: LocalDate,
    marketValue: z.number(),
});
export const Transaction = z.object({
    action: z.string(),
    transactionType: TransactionType,
    transactionSubtype: TransactionSubtype,
    marketValue: z.string().transform((val, ctx) => {
        if (Number.isNaN(Number(val))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `Received non-numeric string ${val}`,
            });
            return z.NEVER;
        }
        return parseFloat(val);
    }),
    description: z.string(),
    settleDate: LocalDate,
    ticker: Ticker,
    quantity: z.string(),
    displayName: z.string(),
});
export const Event = z.object({
    accountId: FartherAccountId,
    transactions: Transaction.array(),
    startingMarketValue: StartingMarketValue.nullable(),
});
export const GetEventsRes = Event.array();
export default async function getEventsV3(accountGroupId, config) {
    const { data } = await axios.get(url(accountGroupId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ...("clientId" in config && { Client: config.clientId }),
        },
    });
    const decoded = GetEventsRes.safeParse(data);
    if (decoded.success) {
        return decoded.data.map((e) => ({
            ...e,
            transactions: e.transactions.map((i) => ({
                ...i,
                //Since transactions do not come back with an ID, we generate a unique ID for each transaction.
                //This helps mapping them in react by using the Id as the key
                id: generateRandomString(),
            })),
        }));
    }
    else {
        const errorMessage = `[${getEventsV3.name}] returned unexpected data`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getEventsV3.js.map